<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">开标大厅</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="sectionCode" label="标段编号" show-overflow-tooltip />
                <el-table-column label="开标时间"  align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getOpeningTime(scope.row.timeInfo) }}
                    </template>
                </el-table-column>
                <el-table-column label="解密结束时间"  align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getDecryptEndTime(scope.row.timeInfo) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="300" fixed="right">
                    <!-- 是否开启双信封 -->
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEnterHall(scope.row)" class="action-btn" v-if="scope.row.envelopeStatus == 0">
                            开标大厅
                        </el-button>
                        <!-- firstEnvelopeCode 不为空 -->
                        <el-button type="text" size="small" @click="handleEnterHall({...scope.row, envelopeType: 'first'})" class="action-btn" v-if="scope.row.firstEnvelopeCode!='' && scope.row.envelopeStatus == 1">
                            一信封开标大厅
                        </el-button>
                        <!-- secondEnvelopeCode 不为空 -->
                        <el-button type="text" size="small" @click="handleEnterHall({...scope.row, envelopeType: 'second'})" class="action-btn" v-if="scope.row.secondEnvelopeCode!='' && scope.row.envelopeStatus == 1">
                            二信封开标大厅
                        </el-button>
                        <!-- 查看备案信息表 -->
                        <el-button type="text" size="small" @click="handleShowFilingForm(scope.row)" class="action-btn">
                            备案信息表
                        </el-button>
                        <!-- 导出投标人信息 -->
                        <el-button type="text" size="small" @click="handleExportEvaluationStep(scope.row)" class="action-btn">
                            导出投标人信息
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 备案信息表对话框 -->
        <el-dialog title="备案信息表" :visible.sync="filingFormDialogVisible" width="820px"
            :close-on-click-modal="false" :append-to-body="true" custom-class="filing-form-dialog">
            <div class="filing-form-tip">
                <i class="el-icon-info"></i>
                <span>未生成的表格可点击「生成」，生成后支持「下载」与「重新生成」。</span>
            </div>
            <el-table :data="filingFormTableData" v-loading="filingFormLoading" border size="small"
                class="filing-form-table">
                <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column label="表格名称" min-width="220" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="filing-name">{{ scope.row.fileName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="生成状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.generated == 1" type="success" size="small">已生成</el-tag>
                        <el-tag v-else type="info" size="small">未生成</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="生成时间" width="180" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.generated == 1" class="filing-time">{{ scope.row.createTime }}</span>
                        <span v-else class="filing-empty">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" v-if="scope.row.generated != 1"
                            @click="handleGenerate(scope.row)">生成</el-button>
                        <el-button type="text" size="small" v-if="scope.row.generated == 1"
                            @click="handleDownload(scope.row)">下载</el-button>
                        <el-button type="text" size="small" class="filing-regen-btn" v-if="scope.row.generated == 1"
                            @click="handleGenerate(scope.row)">重新生成</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { getOpeningList, getOpeningIsMeet, getFilingFormList, generateFilingForm, getFilingFormFile,getEvaluationStepDownloadTxt } from '@/api/modules/agent'
import { loadProjectDetail } from '@/utils/bid/projectInfo'
export default {
    name: 'BidOpeningHall',
    data() {
        return {
            projectTitle: '',
            projectCode: '',
            loading: false,
            tableData: [
            ],
            pagination: {
                currentPage: 1,
                pageSize: 50,
                total: 1
            },
            // 备案信息表对话框
            filingFormDialogVisible: false,
            filingFormLoading: false,
            currentSectionCode: '',
            filingFormTableData: []
        }
    },
    mounted() {
        this.projectCode = this.$route.query.projectCode
        this.loadData()
        this.getProjectInfo()
    },
    methods: {

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 进入开标大厅
        handleEnterHall(row) {
            this.getOpeningIsMeet(row)

        },
        //是否具备进入开标大厅条件
        async getOpeningIsMeet(row) {
            const res = await getOpeningIsMeet(row.sectionCode)
            if (res.code === 200) {
                if(row.envelopeStatus == 0){
                    this.$router.push({ path: '/openHall', query: { projectCode: this.projectCode, sectionCode: row.sectionCode } })
                }else{
                    this.$router.push({ path: '/openHall', query: { projectCode: this.projectCode, sectionCode: row.sectionCode, envelopeCode: row.envelopeType=='first' ? row.firstEnvelopeCode : row.secondEnvelopeCode} })

                }

            } else {
                this.$message.error(res.msg)
            }
        },
        // 导出投标人信息
        async handleExportEvaluationStep(row) {
            try {
                const blob = await getEvaluationStepDownloadTxt(row.sectionCode)
                if (!(blob instanceof Blob)) {
                    this.$message.error('导出失败')
                    return
                }
                const fileBlob = blob.type ? blob : new Blob([blob], { type: 'text/plain;charset=utf-8' })
                const downloadUrl = window.URL.createObjectURL(fileBlob)
                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = `投标人信息-${row.sectionCode}.txt`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(downloadUrl)
                this.$message.success('导出成功')
            } catch (error) {
                this.$message.error(error?.message || '导出失败')
            }
        },
        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        getOpeningTime(timeInfo) {
            return this.splitTimeInfo(timeInfo)[0]
        },

        getDecryptEndTime(timeInfo) {
            return this.splitTimeInfo(timeInfo)[1]
        },

        splitTimeInfo(timeInfo) {
            const text = timeInfo ? String(timeInfo) : ''
            if (!text) {
                return ['-', '-']
            }

            let parts = text.split('--')
            if (parts.length < 2) {
                parts = text.split('—')
            }
            if (parts.length < 2) {
                parts = text.split('－')
            }
            if (parts.length >= 2) {
                return [parts[0].trim() || '-', parts.slice(1).join('--').trim() || '-']
            }

            return [text.trim() || '-', '-']
        },

        // 加载数据
        loadData() {
            this.loading = false
            this.getOpeningList()
        },
        //获取开标大厅列表
        async getOpeningList() {
            const res = await getOpeningList(this.projectCode)
            if (res.code === 200) {
                this.tableData = res.data.list
                this.pagination.total = res.data.total
            }
        },

        // 查看备案信息表
        handleShowFilingForm(row) {
            this.currentSectionCode = row.sectionCode
            this.filingFormDialogVisible = true
            this.loadFilingFormList()
        },

        // 获取备案信息表生成状态
        async loadFilingFormList() {
            this.filingFormLoading = true
            try {
                const res = await getFilingFormList(this.currentSectionCode)
                // 直接取后台返回的列表，前端不限制表格类型
                this.filingFormTableData = (res.code === 200 && Array.isArray(res.data)) ? res.data : []
            } catch (error) {
                console.error('获取备案信息表失败:', error)
            } finally {
                this.filingFormLoading = false
            }
        },

        // 生成 / 重新生成备案信息表
        async handleGenerate(row) {
            const isRegenerate = row.generated == 1
            try {
                await this.$confirm(
                    isRegenerate ? `确定重新生成「${row.fileName}」吗？将覆盖原有文件。` : `确定生成「${row.fileName}」吗？`,
                    '提示',
                    { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' }
                )
            } catch (e) {
                return
            }
            const res = await generateFilingForm(this.currentSectionCode, row.fileType)
            if (res.code === 200) {
                this.$message.success(isRegenerate ? '重新生成成功' : '生成成功')
                this.loadFilingFormList()
            } else {
                this.$message.error(res.msg || '操作失败')
            }
        },

        // 下载备案信息表（下载前重新获取最新文件地址）
        async handleDownload(row) {
            if (!row.fileGuid) {
                this.$message.warning('文件不存在')
                return
            }
            const res = await getFilingFormFile(row.fileGuid)
            if (res.code !== 200 || !res.data || !res.data.fileUrl) {
                this.$message.error((res && res.msg) || '获取文件失败')
                return
            }
            const link = document.createElement('a')
            link.href = res.data.fileUrl
            link.download = res.data.fileName || row.fileName || '备案信息表'
            link.target = '_blank'
            link.rel = 'noopener'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    },


}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部（带返回按钮）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

// 操作列按钮较多时紧凑排布，避免过宽
.table-section {
    /deep/ .action-btn {
        padding-left: 6px;
        padding-right: 6px;
        margin-right: 4px;

        &:last-child {
            margin-right: 0;
        }
    }
}

// 备案信息表对话框
.filing-form-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    margin-bottom: 16px;
    background: @info-bg;
    border: 1px solid @info-border;
    border-radius: 4px;
    color: @gray-600;
    font-size: 13px;
    line-height: 1.5;

    i {
        color: @info-color;
        font-size: 14px;
        flex-shrink: 0;
    }
}

.filing-form-table {
    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600 !important;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }

    /deep/ .el-table__row:hover > td {
        background-color: @gray-50;
    }

    /deep/ .el-table__cell .cell {
        padding-left: 12px;
        padding-right: 12px;
    }

    .filing-name {
        font-weight: 500;
        color: @gray-700;
    }

    .filing-time {
        color: @gray-500;
        font-size: 13px;
    }

    .filing-empty {
        color: @gray-400;
    }

    .filing-regen-btn {
        color: @warning-color;

        &:hover,
        &:focus {
            color: @warning-color;
        }
    }
}
</style>

<style lang="less">
// 备案信息表对话框（append-to-body，需全局样式）
.filing-form-dialog {
    border-radius: 6px;
    overflow: hidden;

    .el-dialog__header {
        background: #fafafa;
        padding: 16px 20px;
        border-bottom: 1px solid #e8e8e8;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: #4a4a4a;
        }
    }

    .el-dialog__body {
        padding: 20px 24px;
    }
}
</style>
